<template>
    <section id="miners" class="row bg-Light">
        <div class="container my-5">
            <div class="row">
                <div class="col mb-5 text-center">
                    <h3>Kies jouw SkyMiner</h3>
                    <div>
                        Bereken je winst per
                        <span class="dropdown">
                            <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" id="periodDropdown">
                                {{ selectedPeriod.label }}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="periodDropdown">
                                <li v-for="option in data.periodChoices" :key="option.value">
                                    <a class="dropdown-item"
                                       href="#"
                                       @click.prevent="selectPeriod(option)">
                                        {{ option.label }}
                                    </a>
                                </li>
                            </ul>
                        </span>
                        op basis van 1 BTC =
                        <span class="dropdown">
                            <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="bitcoinDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ selectedBtcInEur.label }}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="bitcoinDropdown">
                                <li v-for="option in data.btcInEurChoices" :key="option.value">
                                    <a class="dropdown-item"
                                       href="#"
                                       @click.prevent="selectBtcInEur(option)">
                                        {{ option.label }}
                                    </a>
                                </li>
                            </ul>
                        </span>
                    </div>
                    <div>De huidige koers van 1 BTC is € {{ formattedBtcPrice }}</div>
                </div>
            </div>
            <div class="row g-4">
                <div class="col-12 col-sm-6 col-lg-3" v-for="miner in data.miners" :key="miner.Id">
                    <miner-card :miner="miner" :periodInDays="selectedPeriod.value" :btcToEurRate="selectedBtcInEur.value" :costPerPerWattPerDay="data.costPerPerWattPerDay" :bitcoinPayoutPerTeraHashPerDay="data.bitcoinPayoutPerTeraHashPerDay" />
                </div>
            </div>
            <div class="row g-4 mt-3">
                <div class="col-12 col-sm-6 col-lg-3" v-for="subscription in data.subscriptions" :key="subscription.Id">
                    <subscription-card :subscription="subscription" />
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import MinerCard from '@/components/MinerCard.vue';
import SubscriptionCard from '@/components/SubscriptionCard.vue';

export default {
  name: "HomeIndex",
  components: { MinerCard, SubscriptionCard },
  props: {
    data: Object
  },
  data() {
    return {
        selectedPeriod: this.data.selectedPeriod,
        selectedBtcInEur: this.data.selectedBtcInEur,
    };
  },
  computed: {
      formattedBtcPrice() {
        return new Intl.NumberFormat('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(this.data.bitcoinPriceInEuro);
      }
  },
  methods: {
    selectPeriod(option) {
      this.selectedPeriod = option;
      },
      selectBtcInEur(option) {
          this.selectedBtcInEur = option;
      } 
  }
};
</script>